module.exports = __webpack_public_path__ + "static/media/ceilings_lcs_60yd_y.616a89b2.csv";